// extracted by mini-css-extract-plugin
export default {"page":"LoadingPage_page__t-lXW","page__loader":"LoadingPage_page__loader__8+DDB","page__img":"LoadingPage_page__img__Wf23B","StrokeMove":"LoadingPage_StrokeMove__E4Pqg"};